import { Actions } from '../actions/analytics';
import { EnergyRecommendation } from '../types/analytics';

const initialState = {};
interface State {
  [key: string]: EnergyRecommendation[];
}

export default (state: State = initialState, action: any) => {
  switch (action.type) {
    case Actions.ENERGY_SUCCESS: {
      const { siteId, data } = action.payload;
      if (!siteId) return state;
      return {
        ...state,
        [siteId]: data,
      };
    }

    default:
      return state;
  }
};
